module.exports = __webpack_public_path__ + "img/furniture.de51fbf6.png";